import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { IonApp, IonRouterOutlet } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
//import {StatusBarStyle, Plugins} from '@capacitor/core';
import Home from './pages/Home';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';

//MAIN PAGES 
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Plan from './pages/Plan';
import Mindset from './pages/Mindset';
import Analyze from './pages/Analyze'

//MINDSET PAGES
import MindsetView from './pages/MindSet_Pages/MindsetView';
import Create from "./pages/MindSet_Pages/CreateMindset"; //moving into MindSet_Pages
import Posts from "./pages/Posts";
import Learn from "./pages/MindSet_Pages/Learn"; 
import Practice from "./pages/MindSet_Pages/Practice"; 

//PLAN PAGES
import Maps from "./pages/MindMap_Pages/Maps"; 
import MindMapView from './pages/MindMap_Pages/MindmapView'; //IN
import MindMap from './pages/MindMap_Pages/CreateMindMap'; //moving into MindMap_Pages

//EXPLORE PAGES
import Explore from "./pages/Explore";
import CreateExploration from "./pages/Explore_Pages/CreateExploration";
import EditMarkers from "./pages/Explore_Pages/EditMarkers";
import ViewExploration from "./pages/Explore_Pages/ViewExploration";

//ANALYZE PAGES
import CreateFieldNote from "./pages/Analyze/CreateFieldnote";
import ViewFieldNote from "./pages/Analyze/FieldNoteView";
import Notes from "./pages/Analyze/Notes";


import VideoPlayerFullscreen from './pages/VideoPlayerFullscreen';

const App: React.FC = () => (
   
    <IonApp>
       
        <IonReactRouter>
            <IonRouterOutlet>
                <Route path="/home" component={Home} exact={true} />
                <Route path="/home/:message" component={Home} exact={true} />
                <Route path="/register" component={Register} exact={true} />
                <Route path="/dashboard/" component={Dashboard} exact={true} />
                <Route path="/dashboard/:id" component={Dashboard} exact={true} />

                <Route path="/mindset" component={Mindset} exact={true} />
                <Route path="/createmindset" component={Create} exact={true} />
                <Route path="/viewmindset" component={MindsetView} exact={true} />
                <Route path="/viewmindset/:catid" component={MindsetView} exact={true} />
                <Route path="/mindset/:catid" component={Mindset} exact={true} />
                <Route path="/post/:postid" component={Posts} exact={true} />
                <Route path="/learn" component={Learn} exact={true} />
                <Route path="/practice" component={Practice} exact={true} />

                
                <Route path="/createmindmap" component={MindMap} exact={true} />
                <Route path="/viewmindmap" component={MindMapView} exact={true} />
                <Route path="/map/:postid" component={Maps} exact={true} />

                <Route path="/explore" component={Explore} exact={true} />
                <Route path="/createexploration" component={CreateExploration} exact={true} />
                <Route path="/viewexploration" component={ViewExploration} exact={true} />
                <Route path="/editmarkers" component={EditMarkers} exact={true} />
                <Route path="/editmarkers/" component={EditMarkers} exact={true} />
                <Route path="/editmarkers/:categoryid/:color/:name" component={EditMarkers} exact={false} />
                
                <Route path="/fullscreen" component={VideoPlayerFullscreen} />

                <Route path="/plan" component={Plan} exact={true} />
                <Route path="/plan/:categoryid" component={Plan} exact={true} />

                <Route path="/analyze" component={Analyze} exact={true} />
                <Route path="/createfieldnote" component={CreateFieldNote} exact={true} />
                <Route path="/viewfieldnote" component={ViewFieldNote} exact={true} />
                <Route path="/notes" component={Notes} exact={true} />
                <Route path="/notes/:postid" component={Notes} exact={true} />


                <Route exact path="/" render={() => <Redirect to="/home" />} />
            </IonRouterOutlet>
        </IonReactRouter>
    </IonApp>
);
export default App;
